'use strict';

angular.module('app')
  .directive('jumpToNext', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var elem = $(element),
          jumpTo = $('input[name=' + attr.jumpToNext + ']'),
          jumpPrev = $('input[name=' + attr.jumpPrev + ']'),
          characterReg = /^\d{2}$/;

        elem.keyup(function(e) {
          var inputVal = $(this).val();

          $timeout(function() {
            if (characterReg.test(inputVal) && !elem.hasClass('ng-invalid')) {
              jumpTo.focus();
            }
          });

          if(e.keyCode == 8 && inputVal.length === 0 && jumpPrev){
            jumpPrev.focus();
          }
        });
      }
    };
  });